var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "btn-cu btn-color-estandar",
      class: [{ "btn-fw": _vm.fullWidth }, "btn-" + _vm.size],
      attrs: { title: "Inicia sesión con ClaveÚnica" },
      on: {
        click: function($event) {
          return _vm.handleClick()
        }
      }
    },
    [
      _c("img", {
        staticClass: "cl-claveunica",
        attrs: { src: require("@/assets/images/cu-blanco.svg") }
      }),
      _c("span", { staticClass: "texto" }, [_vm._v("Iniciar sesión")])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }